
module.exports = {
	GLOBAL_NAV_CLICK: "GlobalNavClick",
	FOOTER_CLICK: "FooterClick",
	EDUCATION_CLICK: "EducationClick",
	AGA_EDUCATION_CLICK: "AGAEducationClick",
    APP_DOWNLOAD_CLICK: "AppDownloadClick",
    LOGIN_CLICK: "LoginClick",
    LOGIN_WITH_FACEBOOK_CLICK: "LoginWithFacebookClick",
    REGISTER_CLICK: "RegisterClick",
    PASSWORD_RESET_CLICK: "PasswordResetClick",
    CONDITION_CLICK: "ConditionClick",
    TREATMENT_CLICK: "TreatmentClick",
    PROFILE_CLICK: "ProfileClick",
    SURVEY_BUTTON_CLICKED: "SurveyButtonClicked",
    SURVEY_STARTED: "SurveyStarted",
    SURVEY_COMPLETED: "SurveyCompleted",
    DASHBOARD_CLICK: "DashboardClick",
	FIND_A_SPECIALIST_CLICK: "FindASpecialistClick",
	CLINICAL_TRIALS_CLICK: "ClinicalTrialsClick",
	CLINICAL_TRIALS_SUCCESS: "ClinicalTrialsSuccess",
	CLINICAL_TRIALS_QUESTION: "ClinicalTrialsQuestion",
	COLLECT_ZIP_CODE_META: "CollectZipCodeMeta"
};



// WEBPACK FOOTER //
// ./src/common/modules/meta/constants.js